import UserCenterInfo from "./UserCenterInfo";

export default UserCenterInfo;